import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2528 6.54496L11.2529 6.54491L11.2443 6.5364L9.7736 5.07604C9.58627 4.89003 9.33299 4.78564 9.069 4.78564H3.71436C3.16207 4.78564 2.71436 5.23336 2.71436 5.78564V18.2142C2.71436 18.7665 3.16207 19.2142 3.71436 19.2142H20.2858C20.8381 19.2142 21.2858 18.7665 21.2858 18.2142V7.85707C21.2858 7.30479 20.8381 6.85707 20.2858 6.85707H12.0001H11.5597L11.2528 6.54496Z",
		fill: "#cadeff",
		stroke: "#0f172b",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})
});
export default SvgFolderIcon;
